import React from 'react';
import { PropTypes } from 'prop-types';
import { components } from 'react-select';
import Icon from '@mdi/react';
import { mdiChevronDown } from '@mdi/js';

const { DropdownIndicator } = components;
const DropdownIcon = ({ data, ...props }) => {
  return (
    <DropdownIndicator {...props}>
      <Icon path={mdiChevronDown} size={1} />
    </DropdownIndicator>
  );
};

DropdownIcon.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string,
      icon: PropTypes.string,
    }).isRequired,
  ),
};

export default DropdownIcon;
